import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { useSetPosOrderTip } from "@/shared/atoms/usePosOrderTipAtom";
import {
  useHasSession,
  useShowPayments,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import usePosOrderTipHook from "@/shared/hooks/usePosOrderTipHook";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";

const useTipAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const { setTip, tip } = usePosOrderTipHook();
  const setPosOrderTip = useSetPosOrderTip();
  const hasSession = useHasSession();
  const showPayments = useShowPayments();

  return {
    name: "tip" as CurrentActionTypes,
    label: t("posOrders.tip"),
    set: setTip,
    deleteAction: () => setPosOrderTip("-1"),
    hasDeleteAction: Boolean(tip && tip !== "-1"),
    filtered: false,
    disabled: hasSession ? !showPayments : false,
    iconVariant: "sackDollar",
  };
};

const TipAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useTipAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default TipAction;
